var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9998 16C1.66647 16 1.38314 15.8833 1.1498 15.65C0.916471 15.4167 0.799805 15.1333 0.799805 14.8C0.799805 14.4667 0.916471 14.1833 1.1498 13.95C1.38314 13.7167 1.66647 13.6 1.9998 13.6C2.33314 13.6 2.61647 13.7167 2.8498 13.95C3.08314 14.1833 3.1998 14.4667 3.1998 14.8C3.1998 15.1333 3.08314 15.4167 2.8498 15.65C2.61647 15.8833 2.33314 16 1.9998 16ZM1.9998 9.2C1.66647 9.2 1.38314 9.08333 1.1498 8.85C0.916471 8.61667 0.799805 8.33333 0.799805 8C0.799805 7.66667 0.916471 7.38333 1.1498 7.15C1.38314 6.91667 1.66647 6.8 1.9998 6.8C2.33314 6.8 2.61647 6.91667 2.8498 7.15C3.08314 7.38333 3.1998 7.66667 3.1998 8C3.1998 8.33333 3.08314 8.61667 2.8498 8.85C2.61647 9.08333 2.33314 9.2 1.9998 9.2ZM1.9998 2.4C1.66647 2.4 1.38314 2.28333 1.1498 2.05C0.916471 1.81667 0.799805 1.53333 0.799805 1.2C0.799805 0.866666 0.916471 0.583333 1.1498 0.35C1.38314 0.116667 1.66647 0 1.9998 0C2.33314 0 2.61647 0.116667 2.8498 0.35C3.08314 0.583333 3.1998 0.866666 3.1998 1.2C3.1998 1.53333 3.08314 1.81667 2.8498 2.05C2.61647 2.28333 2.33314 2.4 1.9998 2.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.cec6d67dc07c71fd1810ca6571de25bf.svg";
export { ForwardRef as ReactComponent };